import { render, staticRenderFns } from "./file-setting-add-or-update.vue?vue&type=template&id=ef8c88a2&scoped=true"
import script from "./file-setting-add-or-update.vue?vue&type=script&lang=js"
export * from "./file-setting-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./file-setting-add-or-update.vue?vue&type=style&index=0&id=ef8c88a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef8c88a2",
  null
  
)

export default component.exports